import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useRef, useState } from 'react'
import { EliminarTipoActivo, GuardarNuevoTipoActivo } from '../../helpers/ActivosHelper';
import { TiposActivoContext } from '../../pages/catalogos/ActivosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalEliminaTipoActivoComponent = () => {
    const {modalEliminaTipoActivo, setModalEliminaTipoActivo, obtenerTipos, tipoActivoSel} = useContext(TiposActivoContext);
    const [tipoActivo, setTipoActivo] = useState();
    const [errorGuardado, setErrorGuardado] = useState(false);
    const refForm = useRef();
    console.log('Valor de modal agrega', modalEliminaTipoActivo);

    const handleClose = () => {
        setModalEliminaTipoActivo(false);
    }

    const handleSubmit =  (event) => {
        event.preventDefault();
        //refForm.current.isValidate();
        EliminarTipoActivo(tipoActivoSel?.IdTipoInstalacion).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerTipos();
                handleClose();

            }
        })
    }

  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalEliminaTipoActivo} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Tipo de Activo</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          ¿Eliminar el tipo de instalación "{tipoActivoSel?.TipoInstalacion}"?
          {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Eliminar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
